"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMerchandiseIdOwned = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _q = _interopRequireDefault(require("q"));

var _getProducts = _interopRequireDefault(require("self-service-api/api/getProducts"));

var _getParcels = _interopRequireDefault(require("self-service-api/api/getParcels"));

var _validators = require("self-service-api/core/validators");

var _isProductOwnedAdapter = _interopRequireDefault(require("self-service-api/adapters/isProductOwnedAdapter"));

var getMerchandiseIdOwned = function getMerchandiseIdOwned(merchandiseIds) {
  merchandiseIds.forEach(function (merchandiseId) {
    return (0, _validators.validateMerchandiseId)(merchandiseId);
  });
  return _q.default.Promise.all([(0, _getProducts.default)(), (0, _getParcels.default)()]).then(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        products = _ref2[0],
        parcels = _ref2[1];

    return merchandiseIds.find(function (merchandiseId) {
      return (0, _isProductOwnedAdapter.default)(products, parcels, merchandiseId);
    });
  });
};

exports.getMerchandiseIdOwned = getMerchandiseIdOwned;